import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

export class AppConfig {
  public ApiUrl: string;
  public ApiBaseUrl: string;
  public BaseSystem: string;
  public Production: boolean;
  public AllowDebug: boolean;
  public AllowConsoleLog: boolean;
  public SupplierPortalV2Enabled: boolean;
  public ModulesV2Enabled: boolean;
  public InstanceOwnerName: string;
  public CrimecastJWTUrl: string;
  public CrimecastApiBaseUrl: string;
  public ModulesV2BaseUrl: string;
}

declare global {
  interface Window {
    __CAP_API_BASES__?: {
      capData?: string;
      modulesV1?: string;
      modulesV2?: string;
      [key: string]: any;
    };
  }
}

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private configuration: AppConfig;

  constructor(private httpClient: HttpClient) {}

  setConfig(): Promise<AppConfig> {
    return this.httpClient
      .get<AppConfig>("./data/app-config.json")
      .toPromise()
      .then((config) => {
        this.configuration = config;

        // add configs to window for web components
        window.__CAP_API_BASES__ = window.__CAP_API_BASES__ || {};
        window.__CAP_API_BASES__.capData = config.CrimecastApiBaseUrl;
        window.__CAP_API_BASES__.modulesV1 = config.ApiBaseUrl;
        window.__CAP_API_BASES__.modulesV2 = config.ModulesV2BaseUrl;

        return config;
      });
  }

  readConfig(): AppConfig {
    return this.configuration;
  }
}
